import { render, staticRenderFns } from "./default-new.vue?vue&type=template&id=17f8df6a"
import script from "./default-new.vue?vue&type=script&lang=js"
export * from "./default-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderAreaNew: require('/vercel/path0/components/HeaderAreaNew.vue').default,FooterContent: require('/vercel/path0/components/FooterContent.vue').default})
